import React from 'react';
export default () => <div>Company</div>;
